import { render } from "./remark.vue?vue&type=template&id=16548c6d&scoped=true&ts=true"
import script from "./remark.vue?vue&type=script&lang=ts"
export * from "./remark.vue?vue&type=script&lang=ts"

import "./remark.vue?vue&type=style&index=0&id=16548c6d&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16548c6d"]])

export default __exports__